export default [
  "Jon Snow",
  "Eddard Stark",
  "Robert Baratheon",
  "Jaime Lannister",
  "Catelyn Stark",
  "Cersei Lannister",
  "Daenerys Targaryen",
  "Jorah Mormont",
  "Viserys Targaryen",
  "Sansa Stark",
  "Arya Stark",
  "Robb Stark",
  "Theon Greyjoy",
  "Brandon Stark",
  "Joffrey Baratheon",
  "Sandor Clegane",
  "Tyrion Lannister",
  "Khal Drogo",
  "Petyr Baelish",
  "Davos Seaworth",
  "Samwell Tarly",
  "Stannis Baratheon",
  "Melisandre",
  "Jeor Mormont",
  "Bronn",
  "Varys",
  "Shae",
  "Margaery Tyrell",
  "Tywin Lannister",
  "Ygritte",
  "Gendry",
  "Tormund",
  "Brienne of Tarth",
  "Ramsay Bolton",
  "Gilly",
  "Daario Naharis",
  "Missandei",
  "Ellaria Sand",
  "Tommen Baratheon",
  "Jaqen H'ghar",
  "Roose Bolton",
  "Grey Worm"
];
